export const vtoConstants = {
    GET_WORK_LOC_SUCCESS:"GET_WORK_LOC_SUCCESS",
OFFERS_TABLE_SUCCESS:"OFFERS_TABLE_SUCCESS",
OFFERS_TABLE_BATCH:"OFFERS_TABLE_BATCH",
OFFER_DETAIL:"OFFER_DETAIL",
OFFER_DETAIL_SUCCESS:"OFFER_DETAIL_SUCCESS",
SHOW_LOADER:"SHOW_LOADER",
CLEAN_UP:"CLEAN_UP",
ACTION_REQUEST_SUCCESS:"ACTION_REQUEST_SUCCESS",
SUBMIT_REQUEST_SUCCESS:"SUBMIT_REQUEST_SUCCESS",
SUBMIT_REQUEST:"SUBMIT_REQUEST",
SUBMIT_RESPONSE_SUCCESS:"SUBMIT_RESPONSE_SUCCESS",
GET_EMP_REQ_SUCCESS:"GET_EMP_REQ_SUCCESS",
GET_EMP_REQ:"GET_EMP_REQ",
GET_EMP_SHIFT:"GET_EMP_SHIFT",
GET_EMP_SHIFT_SUCCESS:"GET_EMP_SHIFT_SUCCESS",
SHOW_ERROR:"SHOW_ERROR",
GET_REQ_BUNDLE_SUCCESS:"GET_REQ_BUNDLE_SUCCESS",
GET_REQ_BUNDLE:"GET_REQ_BUNDLE",
SUBMIT_OFFERS_BATCH_SUCCESS:"SUBMIT_OFFERS_BATCH_SUCCESS",
SUBMIT_OFFERS_BATCH:"SUBMIT_OFFERS_BATCH",
SUBMIT_CONFIRM_REQUEST_SUCCESS:"SUBMIT_CONFIRM_REQUEST_SUCCESS",
SUBMIT_CONFIRM_REQUEST:"SUBMIT_CONFIRM_REQUEST",
CREATE_OFFERS_RESPONSE_SUCCESS:"CREATE_OFFERS_RESPONSE_SUCCESS",
UPDATE_SLOTS_SUCCESS: "UPDATE_SLOTS_SUCCESS",
UPDATE_SLOTS: "UPDATE_SLOTS",
UPDATE_STATUS: "UPDATE_STATUS",
SUBMIT_REQ_RESOLUTION: "SUBMIT_REQ_RESOLUTION",
SUBMIT_REQ_RESOLUTION_SUCCESS: "SUBMIT_REQ_RESOLUTION_SUCCESS",
GET_WORK_LOCATIONS: "GET_WORK_LOCATIONS",
GET_CHANGE_LOG: "GET_CHANGE_LOG",
GET_CHANGE_LOG_SUCCESS: "GET_CHANGE_LOG_SUCCESS",
GET_CHANGE_LOG_RESPONSE: "GET_CHANGE_LOG_RESPONSE",
GET_VTO_STATION_LIST: "GET_VTO_STATION_LIST",
GET_VTO_STATION_LIST_SUCCESS: "GET_VTO_STATION_LIST_SUCCESS",
GET_VTO_STATION_LIST_RESPONSE: "GET_VTO_STATION_LIST_RESPONSE",
SUBMIT_EDIT_CUT_OFF: "SUBMIT_EDIT_CUT_OFF",
SUBMIT_EDIT_CUT_OFF_SUCCESS: "SUBMIT_EDIT_CUT_OFF_SUCCESS",
OFFERS_TABLE_FAILED: "OFFERS_TABLE_FAILED",
ADD_MANUAL_SHIFT: "ADD_MANUAL_SHIFT",
DELETE_MANUAL_SHIFT: "DELETE_MANUAL_SHIFT",
GET_FORECAST: "GET_FORECAST",
GET_FORECAST_SUCCESS: "GET_FORECAST_SUCCESS",
GET_FORECAST_DATA: "GET_FORECAST_DATA",
GET_FORECAST_INTERVALS: "GET_FORECAST_INTERVALS",
GET_FORECAST_INTERVALS_SUCCESS: "GET_FORECAST_INTERVALS_SUCCESS",
GET_FORECAST_INTERVALS_DATA: "GET_FORECAST_INTERVALS_DATA",
GET_DEPARTMENT_SERVICES: "GET_DEPARTMENT_SERVICES",
GET_DEPARTMENT_SERVICES_SUCCESS: "GET_DEPARTMENT_SERVICES_SUCCESS",
GET_DEPARTMENT_SERVICES_DATA: "GET_DEPARTMENT_SERVICES_DATA",
GET_POTENTIAL_SAVINGS: 'GET_POTENTIAL_SAVINGS',
GET_POTENTIAL_SAVINGS_SUCCESS: 'GET_POTENTIAL_SAVINGS_SUCCESS',
GET_POTENTIAL_SAVINGS_FAILURE: 'GET_POTENTIAL_SAVINGS_FAILURE',
}